
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 80 80"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#52A728","d":"M67.36 22H19.73c-1.62 0-2.89 1.41-2.64 2.95l4.14 26.68a2.62 2.62 0 002.64 2.18h39.32c1.3 0 2.45-.92 2.64-2.18l4.14-26.68A2.59 2.59 0 0067.36 22z"}}),_c('path',{attrs:{"fill":"#A8D393","d":"M26.9 67.5c3.03 0 5.5-2.38 5.5-5.32a5.42 5.42 0 00-5.5-5.32 5.42 5.42 0 00-5.51 5.32 5.42 5.42 0 005.5 5.32zm33.68 0c3.04 0 5.5-2.38 5.5-5.32a5.42 5.42 0 00-5.5-5.32 5.42 5.42 0 00-5.5 5.32 5.42 5.42 0 005.5 5.32zM28.7 16.4H12.27A2.23 2.23 0 0110 14.22c0-1.2 1.02-2.22 2.29-2.22h16.45c1.24 0 2.26.98 2.26 2.18 0 1.2-1.02 2.22-2.3 2.22z"}})])
          )
        }
      }
    